const variantSelector = document.querySelector('input[name="id"]');


function getSelectedVariant() {


    const variantId = variantSelector.value;
    const variant = product.variants.find(v => v.id == variantId);
   
    if (variant) return variant;

    return null;
}


function updateStock(){
    const variant = getSelectedVariant();
    
    if(variant){
        let backinStockButton = document.getElementById('Globo-Back-In-Stock');
        if(backinStockButton){
            if(variant.available){
                backinStockButton.style.display = 'none';
            }else{
                backinStockButton.style.display = 'block';
            }
        }

    }
}

function updateBadge() {
  var variant = getSelectedVariant();
  var badge = document.querySelector('.thb-product-detail.product .pcb.badge.onsale');

  let url = "/variants/"+variant.id;


  var badgeContainer = document.querySelector('.product-image-container.product-image-container--thumbnails');

  let badgeSelector = '.product-image-container.product-image-container--thumbnails .product-card--badges';

  const oldTag = document.querySelector(badgeSelector);


  fetch(url)
        .then(res => res.text())
        .then(html => {
            // Étape 4 : Parse le HTML retourné
            const parser = new DOMParser();
            const doc = parser.parseFromString(html, 'text/html');

            const newTag = doc.querySelector(badgeSelector);
            

            if (oldTag) {
              oldTag.parentNode.removeChild(oldTag);
            }

            if (newTag && badgeContainer) {
              badgeContainer.insertBefore(document.importNode(newTag, true), badgeContainer.firstChild);
            }

         
        })
        .catch(error => {
            console.error('❌ Erreur AJAX :', error);
        });


}


function updateOptions() {
  document.querySelectorAll('.product-form__input-wrapper input[type="radio"]').forEach(function(input) {
    var value = input.value;
    var optionName = input.name;
    var optionIndex = product.options.indexOf(optionName);
    if (optionIndex === -1) return; // ignore les --sticky et autres

    var label = document.querySelector('label[for="' + input.id + '"]');

    var exists = product.variants.some(function(v) {
      if (v["option" + (optionIndex + 1)] !== value) return false;

      // Vérifier que les options PRÉCÉDENTES matchent les radios cochés
      for (var i = 0; i < optionIndex; i++) {
        var prevName = product.options[i];
        var prevChecked = document.querySelector(
          'input[type="radio"][name="' + prevName + '"]:checked'
        );
        if (prevChecked && v["option" + (i + 1)] !== prevChecked.value) return false;
      }
      return true;
    });

    if (exists) {
      input.style.display = "";
      label && (label.style.display = "");
    } else {
      input.style.display = "none";
      label && (label.style.display = "none");
    }
  });
}

function selectFirstAvailableVariant(changedInput) {
  // 1ère passe : essayer de garder la dimension actuellement sélectionnée
  var firstAvailable = product.variants.find(function(v) {
    return product.options.every(function(optionName, i) {
      var optionKey = "option" + (i + 1);
      if (changedInput.name === optionName) {
        return v[optionKey] === changedInput.value;
      }
      var currentChecked = document.querySelector(
        'input[type="radio"][name="' + optionName + '"]:checked'
      );
      if (currentChecked && product.options.indexOf(optionName) < product.options.indexOf(changedInput.name)) {
        // Options PRÉCÉDENTES : respecter ce qui est déjà sélectionné
        return v[optionKey] === currentChecked.value;
      }
      // Options SUIVANTES : essayer de garder la valeur actuelle
      if (currentChecked) {
        return v[optionKey] === currentChecked.value;
      }
      return true;
    }) && v.available;
  });

  // 2ème passe : si la dimension actuelle n'existe pas pour la couleur choisie,
  // prendre la première dimension disponible
  if (!firstAvailable) {
    firstAvailable = product.variants.find(function(v) {
      return product.options.every(function(optionName, i) {
        var optionKey = "option" + (i + 1);
        if (changedInput.name === optionName) {
          return v[optionKey] === changedInput.value;
        }
        var currentChecked = document.querySelector(
          'input[type="radio"][name="' + optionName + '"]:checked'
        );
        if (currentChecked && product.options.indexOf(optionName) < product.options.indexOf(changedInput.name)) {
          return v[optionKey] === currentChecked.value;
        }
        // Options SUIVANTES : libre (première dispo)
        return true;
      }) && v.available;
    });
  }

  if (!firstAvailable) return;

  product.options.forEach(function(optionName, i) {
    var optionKey = 'option' + (i + 1);
    var target = document.querySelector(
      'input[type="radio"][name="' + optionName + '"][value="' + firstAvailable[optionKey] + '"]'
    );
    if (target && !target.checked) {
      target.checked = true;
      target.dispatchEvent(new Event('change', { bubbles: true }));
    }
  });
}


variantSelector.addEventListener('change', function (e) {
    updateStock();
    updateBadge();
    updateOptions();
})

document.querySelectorAll('.product-form__input-wrapper input[type="radio"]').forEach(function(input) {
  input.addEventListener('change', function() {
    updateOptions();
    selectFirstAvailableVariant(input);
  });
});


const observer = new MutationObserver(function (mutations, obs) {
  const el = document.querySelector('#Globo-Back-In-Stock');
  if (el) {
    updateStock();
    updateBadge();
    updateOptions();
    obs.disconnect(); // Stop l'observation
  }
});

observer.observe(document.body, {
  childList: true,
  subtree: true
});

document.addEventListener('DOMContentLoaded', function() {
 updateOptions();
});